import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';

interface ListLinkItemsRefs {
  elementRef?: RefObject<HTMLElement | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
  iconRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: ListLinkItemsRefs,
): void {
  if (elementRef?.current) {
    timeline.fromTo(elementRef.current, {}, {});
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: ListLinkItemsRefs,
): void {
  if (elementRef?.current) {
    timeline.add(fadeTo(elementRef.current as HTMLElement));
  }
}

export function setupMouseEnterTimeline(
  timeline: gsap.core.Timeline,
  { backgroundRef, iconRef }: ListLinkItemsRefs,
): void {
  if (backgroundRef?.current) {
    timeline.set(backgroundRef.current, { opacity: 1 });
    timeline.fromTo(
      backgroundRef.current,
      { scaleY: 0 },
      { scaleY: 1, duration: 0.4, ease: 'Expo.easeOut' },
    );
  }

  if (iconRef?.current) {
    timeline.fromTo(
      iconRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.4, ease: 'Expo.easeOut' },
      '<',
    );
  }
}

export function setupMouseLeaveTimeline(
  timeline: gsap.core.Timeline,
  { backgroundRef, iconRef }: ListLinkItemsRefs,
): void {
  if (backgroundRef?.current) {
    timeline.to(backgroundRef.current, {
      duration: 0.4,
      ease: 'Expo.easeOut',
      scaleY: 0,
      opacity: 0,
    });
  }

  if (iconRef?.current) {
    timeline.to(
      iconRef.current,
      {
        duration: 0.4,
        ease: 'Expo.easeOut',
        opacity: 0,
      },
      '<',
    );
  }
}
